<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('commentaire.title')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column" :class="[{'is-12': !afficherCommentaireFacture },
        {'is-6': afficherCommentaireFacture}]">
          <commentaire :title="geti18n + '.informations.internCommentary'"
                       v-model="devisCommandeFacture.commentaireInterne"
                       :commentaires="commentaires">
          </commentaire>
        </div>
        <div class="column is-6" v-if="afficherCommentaireFacture">
          <commentaire :title="geti18n + '.informations.quotationCommentary'"
          v-model="devisCommandeFacture.commentaire"
          :commentaires="commentaires">
          </commentaire>
        </div>
        <div class="column is-6" v-if="type !== typeFacture">
          <commentaire :title="geti18n + '.informations.adresseLivraison'"
            v-model="devisCommandeFacture.adresseLivraison"
            :commentaires="commentaires">
          </commentaire>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { TYPE_COMMANDE, TYPE_FACTURE } from '@/configuration/devisConf';
import commentaire from '@/components/general/commentaire';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'DevisCommandeFactureAjoutEditCommentaires',
  props: {
    type: {
      type: String,
      required: true,
    },
    devisCommandeFacture: {
      type: Object,
      required: true,
    },
    afficherCommentaireFacture: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      typeFacture: TYPE_FACTURE,
    };
  },
  components: {
    commentaire,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    geti18n() {
      switch (this.type) {
        case TYPE_COMMANDE:
          return 'editionCommande';
        case TYPE_FACTURE:
          return 'editionFacture';
        default:
          return 'ajoutDevis';
      }
    },
    commentaires() {
      return this.parametre(PARAMETRES_KEYS.commentaire);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        PARAMETRES_KEYS.commentaire,
      ]);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};

</script>
